import React from 'react'
import PropTypes from 'prop-types'
import "../styles/SmallSubscribeForm.sass"
import mysteryIcon from '../../../images/icons/mystery-icon.svg'
import spinner from '../../../images/icons/logo-icon.png'
import { SubmitButton } from '../../shared/buttons';
import { detectEnterPress } from '../../../utils/enterPress';
import { validateEmail } from '../../../utils/validateEmail';
import prose from '../../../assets/prose'
import { contactService } from '../../../services/contactService';

class SmallSubscribeForm extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      email: '',
      firstName: '',
      submitted: false,
      submitting: false,
      angle: 0
    }
    this.imageRef = React.createRef()

    this.submitForm = this.submitForm.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
    this.onFormFieldChanged = this.onFormFieldChanged.bind(this);

    this.getMessage = this.getMessage.bind(this);
    this.getSubMessage = this.getSubMessage.bind(this);
  }

  onKeyUp = (e) => {
    if (detectEnterPress(e)) {
      this.submitForm();
    } 
  }

  startRotation = () => {
    this.setState({ ...this.state, submitting: true });
    this.animationFrame = requestAnimationFrame(this.rotateImage);
  };

  stopRotation = () => { 
    cancelAnimationFrame(this.animationFrame)
  }

  componentWillUnmount() {
    cancelAnimationFrame(this.animationFrame)
  }

  rotateImage = () => {
    this.setState(
      prevState => ({ angle: prevState.angle + 0.5 }), // Adjust speed here
      () => {
        this.imageRef.current.style.transform = `rotate(${this.state.angle}deg)`;
        this.animationFrame = requestAnimationFrame(this.rotateImage);
      }
    );
  };

  onFormFieldChanged = (fieldName, newValue) => {
    this.setState({
      ...this.state,
      [fieldName]: newValue
    })
  }

  submitForm = async () => {
    const { email, firstName } = this.state;
    const isEmailValid = email !== "" && email !== undefined && validateEmail(email);
    // const isFirstNameValid = firstName !== "" && firstName !== undefined;

    if (isEmailValid) {
      this.startRotation();
      await contactService.createOrUpdateContact(email, 'subscribe-form');
      // alert(`Good stuff! I'll let you know when I have something good for you. Cheers, pal.`)
      this.setState({ ...this.state, submitted: true, submitting: false })
      this.stopRotation();
    } else {
      alert('Whoops. Want to try that again with a valid name and email? 🤠')
    }
  }

  getMessage () {
    const { message, noMessage } = this.props;
    if (noMessage) return '';
    if (!!message) {
      return message;
    } else {
      return `Want to be notified when new content comes out?`
    }
  }

  getSubMessage () {
    const { subMessage, noMessage } = this.props;
    if (noMessage) return '';
    if (!!subMessage) {
      return subMessage;
    } else {
      return `Join ${prose.subscriberCount}+ other Software Essentialists`
    }
  }

  render () {
    const { submitted, submitting } = this.state;
    const message = this.getMessage();
    const subMessage = this.getSubMessage();

    return (
      <div className="small-subscribe-form">
        <div className="header">
            {/* <div className="icon-container">
              <img src={mysteryIcon}/>
            </div> */}
            <div className="details">
              <p className="message">
                { message }
              </p>
              <p className="sub-message">{subMessage}</p>
            </div>
        </div>
        {
          submitting ? (
            <div><img ref={this.imageRef} id='rotating-spinner' style={{ maxWidth: '40px' }} src={spinner}/></div>
          ) :
          submitted ? (
            <p className="form submitted">You're in!</p>
          ) : (
            <div className="form">
              {/* <input 
                  onChange={(e) => this.onFormFieldChanged('firstName', e.target.value)}
                  onKeyUp={(e) => this.onKeyUp(e)} 
                  type="text" 
                  placeholder="Your first name"
                /> */}
                <p style={{'marginBottom': '0.5rem'}}></p>
                <input 
                  onChange={(e) => this.onFormFieldChanged('email', e.target.value)}
                  onKeyUp={(e) => this.onKeyUp(e)} 
                  type="text" 
                  placeholder="Your email"
                />
                <SubmitButton 
                  text="Read for free"
                  onClick={() => this.submitForm()}
                />
              </div>  
          )
        }
        <br/>
        <br/>
      </div>
    )
  }
}

export default SmallSubscribeForm;

SmallSubscribeForm.propTypes = {
  message: PropTypes.string,
  subMessage: PropTypes.string
}